// Базовые типы
import {ViewMode} from "./view-types";

export type EntityID = string;
export type LocalID = string; //`local_${string}`;
export type ServerID = number;

export interface Identity
{
	id: EntityID; // Основной ID (может быть local_* или server ID)
	serverId: ServerID | null; // Серверный ID после синхронизации
	localId: LocalID; // Всегда уникальный локальный ID

	// Метаданные
	createdAt: Date;
	updatedAt: Date;
	deletedAt: Date | null;
	isSynced: boolean; // Флаг синхронизации с сервером
	syncVersion: number; // Версия для разрешения конфликтов
}

// Вложение
interface Attachment extends Identity {
	name: string;
	url: string;
	type: string;
	size: number;
}

// Комментарий
interface Comment extends Identity{
	text: string;
	attachments: Attachment[];
}

// Задача
export interface Task extends  Identity{
	// Основные данные
	title: string;
	description: string;
	columnId: EntityID;
	boardId: EntityID;

	// Связанные данные
	comments: Comment[];
	attachments: Attachment[];

	// Расширения для плагинов
	meta: {
		[pluginName: string]: any;
	};
	order: number;
}

// Колонка
export interface Column extends Identity{
	title: string;
	order: number; // Порядок в доске
	boardId: EntityID
}

// Доска
export interface Board  extends Identity, IsEditing{
	title: string;

	// Основные данные
	columns: Column[];
	tasks: Task[];
}

export interface IsEditing {
	// Метаданные
	isEditing?: boolean; // Режим редактирования
}


// Состояние приложения
export interface AppState {
	currentBoards: Board[];
	activeBoardIndex: number;
	viewMode:ViewMode;
	isLoading: boolean;
	lastSyncTime: Date | null;

	showFilters:boolean;
}

export const createIdentity :((localId:EntityID)=> Identity) = (localId:EntityID)=>{
	const now = new Date();
	return {
		id:localId,
		localId: localId,
		serverId:null,
		isSynced: false,
		syncVersion: 0,
		createdAt: now,
		updatedAt: now,
		deletedAt: null,
	}
};
